import { IonButton, IonButtons, IonIcon } from '@ionic/react';
import { arrowBack, bagHandleOutline, restaurantOutline } from 'ionicons/icons';
import React from 'react';

interface Props {
    tipoRetirada: string;
    setTipoRetirada: (tipo: string) => void;
    onNext: () => void;
    onBack: () => void;
}

const TelaRetirada: React.FC<Props> = ({ tipoRetirada, setTipoRetirada, onNext, onBack }) => {
    const opcoes = [
        { valor: 'SALÃO', label: 'Comer Aqui', icone: restaurantOutline, descricao: 'Consumir no estabelecimento' },
        { valor: 'VIAGEM', label: 'Para Levar', icone: bagHandleOutline, descricao: 'Retirar para viagem' },
    ];

    return (
        <div className="totem-tela-retirada">
            <div className="totem-tela-header">
                <IonButtons>
                    <IonButton fill="clear" color="medium" onClick={onBack} className="totem-btn-voltar">
                        <IonIcon icon={arrowBack} slot="icon-only" />
                    </IonButton>
                </IonButtons>
                {/* <h2>Onde vai consumir?</h2> */}
            </div>

            <div className="totem-tela-body">

                <h2>Onde vai consumir?</h2>
                {/* <p>Digite seu nome para personalizar o pedido</p> */}

                <div className="totem-retirada-opcoes">
                    {opcoes.map(opcao => (
                        <div
                            key={opcao.valor}
                            className={`totem-retirada-card ${tipoRetirada === opcao.valor ? 'totem-retirada-card-ativo' : ''}`}
                            onClick={() => { setTipoRetirada(opcao.valor); onNext(); }}
                        >
                            <IonIcon icon={opcao.icone} className="totem-retirada-icone" />
                            <h3>{opcao.label}</h3>
                            <p>{opcao.descricao}</p>
                        </div>
                    ))}
                </div>
            </div>

            {/* <div className="totem-tela-actions">
                <IonButton
                    className="totem-btn"
                    expand="block"
                    color="danger"
                    disabled={!tipoRetirada}
                    onClick={onNext}
                >
                    Continuar
                </IonButton>
            </div> */}
        </div>
    );
};

export default TelaRetirada;
